import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '@ib-shared/shared.module';

import { CheckRegistrEmailLinkComponent } from './check-registr-email-link.component';
import { CheckRegistrEmailLinkRoutingModule } from './check-registr-email-link-routing.module';

@NgModule({
  imports: [CommonModule, SharedModule, CheckRegistrEmailLinkRoutingModule],
  declarations: [CheckRegistrEmailLinkComponent],
})
export class CheckRegistrEmailLinkModule {}
